import { takeLatest, call } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { OptionsService } from '../services/options.service'
import { setMedicationsOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setAreMedicationsOptionsLoading } from '../../addMedicationAdministered/store/addMedicationAdministered.actions'

export function* getMedicationsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    yield put(setAreMedicationsOptionsLoading(true))
    const MedicationsOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getMedicationsOptions,
    ])
    const { entity } = MedicationsOptionsResponse
    entity.sort((e1: any, e2: any) => e1?.name.localeCompare(e2?.name))
    yield put(setMedicationsOptions(entity))
    yield put(setAreMedicationsOptionsLoading(false))
  } catch (e) {
    yield put(throwPcrException(`getMedicationsOptions() error: ${e}`))
  }
}

export function* getMedicationsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getMedicationsOptions)
}
